<template>
  <stat :title="$t('dashboard.offerrepartition.title')" :loading="loading">
    <offer-repartition-chart
      :dataKey="dataKey"
      :height="200"
      :params="params"
      style="width: 100%"></offer-repartition-chart>
  </stat>
</template>

<script>
  import { OfferRepartitionChart } from '@/components/charts'
  import stats from '@/mixins/stats'
  export default {
    components: {
      OfferRepartitionChart
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'offersRevenue'
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/OfferRepartition.vue